import React from 'react';
export function ProductCardSkeleton() {
  return <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100" data-id="element-5855" data-mp="2evi2bxm8rx0a">
      <div className="aspect-[4/5] bg-gray-100 relative overflow-hidden" data-id="element-5856" data-mp="2q4rn8zatsgec">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5857" data-mp="350z5hu2ob7qz" />
      </div>
      <div className="p-3 space-y-3" data-id="element-5858" data-mp="2cdmi5hoouvwm">
        <div className="h-2 bg-gray-100 rounded w-1/4 relative overflow-hidden" data-id="element-5859" data-mp="2ceo6gnuptewa">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5860" data-mp="27f1qi6ni5kjs" />
        </div>
        <div className="space-y-2" data-id="element-5861" data-mp="2m5isbr41uch7">
          <div className="h-3 bg-gray-100 rounded w-full relative overflow-hidden" data-id="element-5862" data-mp="2hc659lf0qdqk">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5863" data-mp="1tn53gh0oy0u9" />
          </div>
          <div className="h-3 bg-gray-100 rounded w-4/5 relative overflow-hidden" data-id="element-5864" data-mp="1onioo357scjc">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5865" data-mp="dpxsox7xz2u6" />
          </div>
        </div>
        <div className="h-4 bg-gray-100 rounded w-1/2 mt-4 relative overflow-hidden" data-id="element-5866" data-mp="miiyzdudzh24">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5867" data-mp="rhuigum510ne" />
        </div>
        <div className="h-9 bg-gray-100 rounded-xl w-full mt-2 relative overflow-hidden" data-id="element-5868" data-mp="3qytwx3kdctji">
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full animate-shimmer" data-id="element-5869" data-mp="3uzcoqxm9hzlp" />
        </div>
      </div>
    </div>;
}
export function ProductGridSkeleton({
  count = 6
}: {
  count?: number;
}) {
  return <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-5870" data-mp="1f880rtex7l4s">
      {Array.from({
      length: count
    }).map((_, i) => <ProductCardSkeleton key={i} data-id="element-5871" data-mp="1k4yg2eiwicp5" data-mpi={i} />)}
    </div>;
}
export function BannerSkeleton() {
  return <div className="w-full rounded-xl overflow-hidden animate-pulse" data-id="element-5872" data-mp="ukqmsbin03zh">
      <div className="w-full h-48 md:h-64 bg-gray-200" data-id="element-5873" data-mp="pirimzf2p31h" />
    </div>;
}
export function SectionSkeleton() {
  return <div className="space-y-4 animate-pulse container mx-auto px-4" data-id="element-5874" data-mp="14g20qrm81766">
      <div className="h-8 bg-gray-100 rounded-lg w-1/3" data-id="element-5875" data-mp="zis68xjz65bh" />
      <div className="h-4 bg-gray-100 rounded-lg w-1/2" data-id="element-5876" data-mp="bs5xf425ch0f" />
      <ProductGridSkeleton count={6} data-id="element-5877" data-mp="bsnzwifejrgs" />
    </div>;
}